import { Common, color } from '@stockbit/ui';
import styled from 'styled-components';

const { Flex, Modal } = Common;

export const AuthModalContainer = styled(Modal)`
  .ant-modal-content {
    border-radius: 3px;
  }
`;

export const ProgressRejectedAuthModalContainer = styled(AuthModalContainer)`
  .ant-modal-body {
    padding: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const LoginTradingModalContainer = styled(AuthModalContainer)`
  .ant-modal-body {
    padding: 40px;
  }
`;

export const CarouselContainer = styled(Flex)`
  width: 360px;
  min-height: 492px;
  background-color: #5dcbad26;
`;

export const RegisterInfoContainer = styled.div`
  width: 391px;
  padding: 40px 32px;
`;

export const RegisterInfoDivider = styled.div`
  width: 1px;
  height: 144px;
  background-color: ${color.downgray};
`;

export const LoginInfoDivider = styled.div`
  width: 185px;
  height: 1px;
  background-color: ${color.downgray};
`;
